import React from 'react';
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { useTranslation } from '../../../app/LanguageContext';

export default function ProductSpecificationsSection({
  attributes = [],
  values = {},
  onChange,
  disabled = false,
}) {
  const { translate } = useTranslation();

  if (!attributes.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        {translate('products.specifications_empty')}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {attributes.map((attr) => {
        const attrId = attr.id ?? attr.ID ?? '';
        const name = attr.name ?? attr.Name ?? '';
        const type = attr.type ?? attr.Type ?? 'text';
        const isRequired = Boolean(attr.is_required ?? attr.IsRequired);
        const options = attr.values ?? attr.Values ?? [];
        const value = values[attrId] ?? '';

        if (type === 'select' || (type === 'checkbox' && options.length > 0)) {
          return (
            <FormControl key={attrId} fullWidth required={isRequired} disabled={disabled}>
              <InputLabel>{name}</InputLabel>
              <Select
                label={name}
                value={value}
                onChange={(e) => onChange?.(attrId, e.target.value)}
              >
                {!isRequired && <MenuItem value="">{translate('common.select')}</MenuItem>}
                {options.map((opt) => (
                  <MenuItem key={opt} value={opt}>
                    {opt}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          );
        }

        if (type === 'checkbox') {
          return (
            <FormControlLabel
              key={attrId}
              control={
                <Checkbox
                  checked={value === 'true' || value === '1'}
                  disabled={disabled}
                  onChange={(e) => onChange?.(attrId, e.target.checked ? 'true' : '')}
                />
              }
              label={
                <>
                  {name}
                  {isRequired ? ' *' : ''}
                </>
              }
            />
          );
        }

        return (
          <TextField
            key={attrId}
            fullWidth
            label={name}
            required={isRequired}
            disabled={disabled}
            value={value}
            onChange={(e) => onChange?.(attrId, e.target.value)}
          />
        );
      })}
    </Box>
  );
}
